export default __webpack_public_path__ + "static/02-fb3f9d05efd3e884c6dd521737e55d0f.jpg";